import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';

export const interactionsRoutes: Routes = [
  {
    path: 'interactions',
    loadComponent: () =>
      import('@feature/customer/interactions/interactions.component').then(
        m => m.InteractionsComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'calender-and-events',
        pathMatch: 'full',
      },
      {
        path: 'calender-and-events',
        canActivate: [permissionGuard('DispatcherCalenderView')],
        loadComponent: () =>
          import('@feature/customer/interactions/calender-and-events/calender-and-events.component').then(
            c => c.CalenderAndEventsComponent
          ),
      },
      {
        path: 'bulletin-board',
        canActivate: [permissionGuard('DispatcherAnnouncementView')],
        loadComponent: () =>
          import('@feature/customer/interactions/bulletin-board/bulletin-board.component').then(
            c => c.BulletinBoardComponent
          ),
      },
    ],
  },
];
